<textarea #answerJson rows="50">{{getContent()}}</textarea>
